const getRemotePaths = () => {
  const defaults = {
    development: {
      KCHAT_API_PATH: 'https://kc-connect.appunite.net/api',
      KCONF_API_PATH: 'https://kingsconference.appunite.com',
      WS_PATH: 'wss://kingsconference.appunite.com',
      AUTH_PATH: 'http://localhost:5050',
      OAUTH_CLIENT_ID: 'com.newmedia.conference.debug',
      COOKIE_DOMAIN: 'localhost'
    },

    testing: {
      KCHAT_API_PATH: 'https://kc-connect.appunite.net/api',
      KCONF_API_PATH: 'https://kingsconference.appunite.com',
      WS_PATH: 'wss://kingsconference.appunite.com',
      AUTH_PATH: 'https://accounts.staging.kingsch.at',
      OAUTH_CLIENT_ID: 'com.newmedia.conference.debug',
      COOKIE_DOMAIN: '.staging.kingsch.at'
    },

    production: {
      KCHAT_API_PATH: 'https://connect.kingsch.at/api',
      KCONF_API_PATH: 'https://conference.kingsch.at',
      WS_PATH: 'wss://conference.kingsch.at',
      AUTH_PATH: 'http://localhost:5050',
      OAUTH_CLIENT_ID: 'com.newmedia.conference',
      COOKIE_DOMAIN: '.kingsch.at'
    }
  };

  const ENV = window.ENV !== '$ENV' ? JSON.parse(window.ENV) : {
    ...defaults[process.env.NODE_ENV]
  };

  const constructAuthPath = () => {
    const accounts = ENV.AUTH_PATH;
    let auth_path = `${accounts}?client_id=${ENV.OAUTH_CLIENT_ID}`;
    auth_path = `${auth_path}&scopes=["conference_calls"]`;
    auth_path = `${auth_path}&redirect_uri=${window.location.protocol}//${window.location.host}`;
    return auth_path;
  };

  return {
    ...ENV,
    AUTH_PATH: constructAuthPath(),
    IDS_WITH_ACCESS_TO_HIDDEN_FEATURES: [
      '58a5a947394f717ff2842725', // milosz
      '538cef4a73312e1109540000', // karol
      '538d076b73322e7e30110400', // thisgokeboysef
      '598831cb6ca2ea3d29ebfaa0', // viktorgunko,
      '539218ed73322e447a470000' // pastorrita
    ]
  };
};

export const REMOTE_PATHS = getRemotePaths();



// WEBPACK FOOTER //
// ./src/constants/remote-paths.constant.js